import { defineMessages } from "react-intl";

const PREFIX = "RegisterPage";
export default defineMessages({
  headerExpired: {
    id: `${PREFIX}.headerExpired`,
    defaultMessage: "Your password has expired and must be changed",
  },
  headerActivated: {
    id: `${PREFIX}.headerExpired`,
    defaultMessage: "Account successfully activated",
  },
  saveButton: {
    id: `${PREFIX}.change`,
    defaultMessage: "Save",
  },
  currentPassword: {
    id: `${PREFIX}.currentPassword`,
    defaultMessage: "Current Password",
  },
  newPassword: {
    id: `${PREFIX}.newPassword`,
    defaultMessage: "New Password",
  },
  confirmPassword: {
    id: `${PREFIX}.confirmPassword`,
    defaultMessage: "Confirm Password",
  },
  passwordLengthHint: {
    id: `${PREFIX}.passwordLengthError`,
    defaultMessage:
      "The password must contain at least eight characters, lowercase and uppercase letters, numbers, and special characters",
  },
  redirectHint: {
    id: `${PREFIX}.redirectHint`,
    defaultMessage: `You will be redirected to the home page after {time} seconds`,
  },
  followLinkHint: {
    id: `${PREFIX}.followLinkHint`,
    defaultMessage: "If it doesn’t happen, follow the link",
  },
  passwordError: {
    id: `${PREFIX}.passwordError`,
    defaultMessage: "Please, check the correctness of the entered data",
  },
  passwordWrongError: {
    id: `${PREFIX}.passwordWrongError`,
    defaultMessage: "Current password was entered incorrectly",
  }

});
